import { apiClient } from "@packages/api-client/src";

// 查询本体对象数据的请求参数
export interface QueryOntologyObjectRequest {
  ontologyId: number;
  conceptName: string;
  selectAttributes?: string[];
  constraints?: {
    attribute: string;
    operator: string;
    value: string;
  }[];
  limit?: number;
}

// 查询本体对象数据的响应
export interface QueryOntologyObjectResponse {
  success: boolean;
  generatedTypeQL: string;
  data: Record<string, any>[];
  total: number;
  executionTime: number;
}

// 查询本体对象数据
export async function queryOntologyObject(
  params: QueryOntologyObjectRequest
): Promise<QueryOntologyObjectResponse> {
  try {
    const response = await apiClient.post<QueryOntologyObjectResponse>(
      '/reason/query-ontology-object',
      params
    );
    return response.data;
  } catch (error) {
    console.error('查询本体对象数据失败:', error);
    throw error;
  }
}
